export class AddressStandardization {
  department = '';
  street = '';
  city = '';
  state = '';
  zip = '';
  country = '';
}
